export default __webpack_public_path__ + "images/image4.f6c10eea.png";